module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/core/usd-70860f265282df1fbbba849a0da1bfe0.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/core/usd.svg
// module id = isoQ
// module chunks = 24